import Moment from 'moment';

import { DATE_TIME_FORMATS } from 'common/constants';

/**
 * Site date-time format
 *
 * @param {string} date - given date
 */
export const dateTimeFormat = (date) => (date ? Moment(date).format(DATE_TIME_FORMATS.BASE) : '');

export default dateTimeFormat;



// WEBPACK FOOTER //
// ./src/common/utils/dateTimeFormat.js